var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34.8216C9.98542 34.8216 3.08337 27.9196 3.08337 19.4049C3.08337 10.8903 9.98542 3.98828 18.5 3.98828C27.0147 3.98828 33.9167 10.8903 33.9167 19.4049C33.9167 27.9196 27.0147 34.8216 18.5 34.8216ZM18.5 17.225L14.1402 12.8637L11.9587 15.0451L16.3201 19.4049L11.9587 23.7648L14.1402 25.9462L18.5 21.5849L22.8599 25.9462L25.0413 23.7648L20.68 19.4049L25.0413 15.0451L22.8599 12.8637L18.5 17.225Z",
    fill: "#B3B7BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5e547715006df3c8d40c0b43658479ed.svg";
export { ForwardRef as ReactComponent };